<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="closeDialog()"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card flat>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">配車依頼作成</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<div class="mt-4 pa-2">
				<template v-if="send_by_fax">
					配車依頼を作成すると変更することはできません。<br />
					本当に作成しますか。
				</template>
				<template v-else>
					配車依頼を作成すると確認依頼のメッセージが送信されます。<br />
					確認がされ次第、メールの送信が可能となります。<br />
					本当に作成しますか。
				</template>
			</div>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-btn
						class="mt-4 mr-4"
						color="secondary"
						dark
						@click="$emit('create-order', send_by_fax ? 'sent' : 'pending')"
					>
						<v-icon class="mr-1">mdi-plus</v-icon>
						作成する</v-btn
					>
					<v-btn class="mt-4 ml-4" @click="closeDialog()">キャンセル</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		send_by_fax: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
	methods: {
		closeDialog() {
			this.showDialog = false
			this.$emit("resetBtnFlag")
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
